<template>
  <div>
    <vxe-grid
      ref="refTable"
      :columns="tableColumn"
      :data="tableData"
      :min-height="30"
      :rowConfig="{
        isCurrent: false
      }"
    >
    </vxe-grid>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tableColumn: [
        {
          title: '序号',
          type: 'seq',
          width: 50
        },
        {
          title: '物料名称',
          field: 'name'
        },
        {
          title: '物料编号',
          field: 'code'
        },
        {
          title: '规格',
          field: 'spec'
        },
        {
          title: '单位',
          field: 'unit'
        },
        {
          title: '数量',
          field: 'counts'
        },
        {
          title: '单价(元)',
          field: 'goods_price'
        },
        {
          title: '金额(元)',
          field: 'goods_amount'
        },
        {
          title: '仓位',
          field: 'cang_wei'
        },
        {
          title: '备注',
          field: 'remark'
        }
      ],
      tableData: []
    }
  },
  mounted() {
    this.initTableData()
  },
  methods: {
    initTableData() {
      let data = this.data || {}
      if (data.tableBomData.length) {
        this.tableData = data.tableBomData || []
        return
      }
      if (data.table_data_2.length) {
        this.tableData = data.table_data_2 || []
        return
      }
      this.tableData = data.table_data_1 || []
    }
  }
}
</script>

<style scoped>
.table-main {
}
</style>
